import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { OperationentityCollectionCatagoryMappingSchema } from '../OperationentityCollectionCatagorySchema';
import { OperationentityCollectionCatagoryMappingListing } from '../Pages/listing';
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'OPERATIONCOLLECTIONCATEGORYMAPPING'

export function OperationentityCollectionCatagoryMapping(props) {

    const { data, edit } = props.location;
    const [title, setTitle] = useState("Collection Category to Product");
    const [groups, setGroups] = useState();
    const [operationEntity, setOperationEntity] = useState();
    const [product, setProduct] = useState();
    const [operationentityCollectionCatagoryMappingData, setOperationentityCollectionCatagoryMappingData] = useState([]);
    const [operationentityCollectionCatagoryMapping, setOperationentityCollectionCatagoryMapping] = useState({
        groupID: '0',
        operationEntityID: '0',
        productID: '0',
    });

    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Completed successfuly."
    });
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(OperationentityCollectionCatagoryMappingSchema).options({ allowUnknown: true });


    useEffect(() => {
trackPromise(
        getGroupsForDropdown()
)
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
            )
    }, [operationentityCollectionCatagoryMapping.groupID])

    useEffect(() => {
        trackPromise(
            getProductsForDropDown()
            )
        handleSearch();
    }, [operationentityCollectionCatagoryMapping.operationEntityID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWOPERATIONCOLLECTIONCATEGORYMAPPINGLISTING');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITOPERATIONCOLLECTIONCATEGORYMAPPING');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !==undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setOperationentityCollectionCatagoryMapping({
            ...operationentityCollectionCatagoryMapping,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });
        
        getGroupsForDropdown();
    }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getOperationEntitiesForDropdown() {
        const opEntities = await services.getAllOperationEntitiesForDropDown(operationentityCollectionCatagoryMapping.groupID);
        setOperationEntity(opEntities);
    }

    async function getProductsForDropDown() {
        const products = await services.getAvialableProducts(operationentityCollectionCatagoryMapping.operationEntityID);
        setProduct(products);
    }

    function validateInputs(target){
        const error = { ...errors }
        const errorMessage = validateProperty(target, OperationentityCollectionCatagoryMappingSchema)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setErrors(error);
    }

    function handleGroupChange(target){
        validateInputs(target);

        setOperationentityCollectionCatagoryMapping({
            ...operationentityCollectionCatagoryMapping,
            groupID: target.value,
            operationEntityID: "0",
            productID: "0"
        });
    }

    function handleOperationEntityChange(target){
        validateInputs(target);

        setOperationentityCollectionCatagoryMapping({
            ...operationentityCollectionCatagoryMapping,
            operationEntityID: target.value,
            productID: "0"
        });
    }

    function handleProductChange(target){
        validateInputs(target);

        setOperationentityCollectionCatagoryMapping({
            ...operationentityCollectionCatagoryMapping,
            productID: target.value,
        });
    }

    async function handleSearch(e) {
        if(e !== undefined){
            const errorMessages = validate(schema, operationentityCollectionCatagoryMapping);
            errorMessages !== null ? setErrors(errorMessages) : setErrors({});
            if (errorMessages) return;
        }

        const response = await services.getOperationentityCollectionCatagoryFilterData(operationentityCollectionCatagoryMapping);
        setOperationentityCollectionCatagoryMappingData(response);
    }

    async function editOperationentityCollectionCatagoryMapping(data) {
        props.history.push({
            pathname: 'opcollectioncatagorymapping/AddEdit',
            data: data,
            edit: true
        });
    }

    function clearState() {
        setOperationentityCollectionCatagoryMapping({
            ...operationentityCollectionCatagoryMapping,
            groupID: '0',
            operationEntityID: '0',
            productID: '0',
        });
        setOperationentityCollectionCatagoryMappingData([]);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={permissionList.isAddEditEnabled}
                                    path="opcollectioncatagorymapping/AddEdit"
                                    buttonText="Add Operationentity Product Mapping"
                                />
                            </div>
                            <hr />

                            <form onSubmit={(e) => handleSearch(e)} disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={operationentityCollectionCatagoryMapping.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={operationentityCollectionCatagoryMapping.operationEntityID}
                                            onChange={(e) => handleOperationEntityChange(e.target)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="productID">Product</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="productID"
                                            id="productID"
                                            name="productID"
                                            value={operationentityCollectionCatagoryMapping.productID}
                                            onChange={(e) => handleProductChange(e.target)}>
                                            <MenuItem value="0">--Select Product--</MenuItem>
                                            {generateDropDownMenu(product)}
                                        </Select>
                                        {errors["productID"] && <FormHelperText error>{errors["productID"]}</FormHelperText>}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, operationentityCollectionCatagoryMapping)}
                                        type="button"
                                        onClick={(e) => handleSearch(e)}
                                        className="btn btn-primary"
                                        value="Search"
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>

                                <OperationentityCollectionCatagoryMappingListing operationentityCollectionCatagoryMappingData={operationentityCollectionCatagoryMappingData} handleClick={editOperationentityCollectionCatagoryMapping} />

                            </form>

                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}